import {
    Building2, FileSliders, Settings, Users, LayoutGrid
} from 'lucide-react';

export default {
    name: 'Organization',
    list: [
        {
            name: 'Studios',
            path: '.',
            icon: <LayoutGrid className="h-5 w-5" />
        },
        {
            name: 'Sub Organizations',
            path: 'sub',
            icon: <Building2 className="h-5 w-5" />
        },
        {
            name: 'Members',
            path: 'members',
            accessRole: 'admin',
            icon: <Users className="h-5 w-5" />
        },
        {
            name: 'Integrations',
            path: 'integrations',
            accessRole: 'admin',
            icon: <FileSliders className="h-5 w-5" />
        },
        {
            name: 'Settings',
            path: 'settings',
            icon: <Settings className="h-5 w-5" />
        },

    ]
};